export enum PaymentType {
  patient = 'Patient Paying',
  insurance = 'Through Insurance',
  included = 'Included',
}

export type PaymentTypeKeys = keyof typeof PaymentType;
